export enum AllowedAuthMethods {
  PanOnly = 'PAN_ONLY',
  Cryptogram3Ds = 'CRYPTOGRAM_3DS',
}
